// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"58bc9fa6","223":"3a0bceef","453":"fd465b35","740":"a06493b3"}[chunkId] + ".chunk.js";
};